import { Link } from 'react-router'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div>
          <div className="footer-brand-name">Hemiciclo</div>
          <p className="footer-desc">Transparencia legislativa para todos los ciudadanos. Información legislativa del Congreso Nacional de Chile.</p>
        </div>
        <div className="footer-col">
          <span className="footer-heading">Descubrir</span>
          <Link to="/">Explorar proyectos</Link>
        </div>
        <div className="footer-col">
          <span className="footer-heading">Sobre</span>
          <Link to="/equipo">Sobre Hemiciclo</Link>
          <a href="mailto:contacto@hemiciclo.cl">Contacto</a>
          <Link to="/terminos">Términos y Condiciones</Link>
        </div>
        <div className="footer-col">
          <span className="footer-heading">Apoyar</span>
          <Link to="/apoyar">Apoya este proyecto</Link>
        </div>
        <div className="footer-col">
          <span className="footer-heading">Redes</span>
          <a href="https://x.com/hemiciclochile" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            Twitter / X
          </a>
          <a href="https://bsky.app/profile/hemiciclo.cl" target="_blank" rel="noopener noreferrer" className="footer-social-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.785 2.627 3.6 3.476 6.26 3.238-4.063.638-7.606 2.398-3.394 8.515H3.5c4.2 5.4 10.5 2.1 12-1.5.1-.2.1-.3.1-.4v-.1c0 .1 0 .2.1.4 1.5 3.6 7.8 6.9 12 1.5h.01c4.212-6.117.669-7.877-3.394-8.515 2.66.238 5.475-.611 6.26-3.238C20.822 9.418 21.2 4.458 21.2 3.768c0-.69-.139-1.861-.902-2.203-.659-.3-1.664-.62-4.3 1.24C13.246 4.747 11.087 8.686 12 10.8z"/></svg>
            Bluesky
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© 2026 Hemiciclo Chile</span>
        <span>Fuente: Congreso Nacional de Chile</span>
      </div>
    </footer>
  )
}
